module.exports = __webpack_public_path__ + "static/img/yytx03.c1086c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx03.png
// module id = 875
// module chunks = 0